<template>
  <transition name='fade'>
    <div class="modal login_box"
         v-if='visible'>
      <div class="login">
        <span class="iconfont el-icon-close"
              @click.stop='closeBox()'></span>
        <div class="login_title">
          <span class="login_each_title"
                v-for='item in loginType'
                :class="[item.id === currentTypeId ? 'login_title_active' : '']"
                @click.stop='choiceLoginType(item)'>
            {{item.name}}
          </span>
        </div>
        <div class="login_type_user"
             v-show="currentTypeId === 'zhanghudenglu'">
          <div class="login_input">
            <el-input placeholder="请输入用户名"
                      clearable
                      prefix-icon="el-icon-user"
                      v-model="userName">
            </el-input>
          </div>
          <div class="login_input"
               style="margin-bottom:10px;">
            <el-input placeholder="请输入密码"
                      prefix-icon="el-icon-user"
                      type='password'
                      clearable
                      v-model="passwrod">
            </el-input>
          </div>
          <div class="login_input">
            <el-checkbox v-model="isRemberPassword">记住密码</el-checkbox>
          </div>
          <div class="login_button">
            <el-button type="primary">登录</el-button>
          </div>
          <div class="login_button">
            <a href="https://center.dacube.cn/#/login/retrieve"
               target="_blank">忘记密码</a>
          </div>
        </div>

        <div class="login_type_qlcode"
             v-show="currentTypeId === 'saomadenglu'">
          <div class="ql_code_img">
            <img src="../../../static/img/test.jpg"
                 alt="二维码">
          </div>
          <div class="ql_code_text">
            <span class="ql_code_text_descrip">请使用融媒体中心APP扫码登录</span>
            <span class="refresh_code">
              <span class="el-icon-refresh-right"></span>
              <span class="refresh">刷新</span>
            </span>

          </div>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'

export default {
  name: 'login',
  data() {
    return {
      visible: false,
      currentTypeId: 'zhanghudenglu',
      passwrod: '',
      loginType: [{ id: 'zhanghudenglu', name: '账户登录' }, { id: 'saomadenglu', name: '扫码登录' }],
      userName: '',
      isRemberPassword: true
    }
  },
  mounted() {
    this.$root.eventHub.$on('loginModal', (type, data) => {
      this.visible = true
    })


  },
  destroyed() {
    this.$root.eventHub.$off('loginModal')
  },
  components: {

  },
  methods: {
    closeBox() {
      this.visible = false
    },
    choiceLoginType(item) {
      this.currentTypeId = item.id
    }

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.login_box
  .login
    position relative
    padding-top 58px
    width 348px
    height 380px
    border-radius 6px
    background #fff

    .iconfont
      position absolute
      top 20px
      right 20px
      color #303133
      font-size 18px
      cursor pointer

    .login_title
      display flex
      margin-bottom 30px
      width 100%

      .login_each_title
        flex 1
        color #606266
        text-align center
        font-weight bold
        font-size 16px
        cursor pointer

      .login_title_active
        color #3582f8

    .login_input
      margin-bottom 20px
      padding-right 20px
      padding-left 20px

    .login_button
      margin-bottom 10px
      padding-left 20px

      button
        width 308px
        height 36px
        line-height 0

      a
        color #909399
        font-size 12px
        cursor pointer

    .login_type_qlcode
      .ql_code_img
        margin-bottom 10px
        width 100%

        img
          display block
          margin 0 auto
          width 211px
          height 209px
          background-color #555

      .ql_code_text
        width 100%
        text-align center

        .ql_code_text_descrip
          time-title()

        .refresh_code
          cursor pointer

          .el-icon-refresh-right
            color #3582f8
            font-size 16px

          .refresh
            margin-left -3px
            color #3582f8
            font-size 14px
</style>
